import { generateDynamicThemeToken } from '../../ThemeProvider';
import { getDynamicThemeToken } from './theme';
import { randomStr } from '../../Shared';
const componentName = 'Dialog';
const prefixName = `ui-${componentName}`;
export const dialogClasses = {
    root: `${prefixName}-root-${randomStr()}`,
    container: `${prefixName}-container-${randomStr()}`,
    backdrop: `${prefixName}-backdrop-${randomStr()}`,
    paperRoot: `${prefixName}-paper-root`,
    scrollAtTop: `${prefixName}-scroll-at-top`,
    scrollAtBottom: `${prefixName}-scroll-at-bottom`,
    titleRoot: `${prefixName}-title-root`,
    titleWithButton: `${prefixName}-title-with-button`,
    contentRoot: `${prefixName}-content-root`,
    content: `${prefixName}-content`,
    disabledContentScrollView: `${prefixName}-disabled-contentScrollView`,
    footerRoot: `${prefixName}-footer-root`,
    closeIcon: `${prefixName}-closeIcon`,
};
export function getStyle(params) {
    const { theme, scroll, width } = params;
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName: 'Dialog',
        theme,
        dynamicToken,
    });
    const styles = {
        // dialog root style
        [`&.${dialogClasses.root}`]: {
            zIndex: tk(token.zIndex),
        },
        // dialog container style
        [`.${dialogClasses.container}`]: {
            [`>.${dialogClasses.paperRoot}`]: {
                '--dialog-margin': tk(token.margin),
                fontFamily: theme?.typography?.fontFamily,
                boxSizing: 'border-box',
                width: width ?? tk(token.width),
                maxWidth: 'none',
                margin: 'var(--dialog-margin)',
                maxHeight: scroll === 'body' ? 'none' : 'calc(100vh - var(--dialog-margin) * 2)',
                borderRadius: tk(token.borderRadius),
                background: tk(token.background),
                boxShadow: tk(token.shadow),
            },
            // title style
            [`.${dialogClasses.titleRoot}`]: {
                padding: tk(token.padding),
                paddingBottom: tk(token.title.paddingBottom),
                color: tk(token.title.color),
                minHeight: tk(token.title.minHeight),
                lineHeight: tk(token.title.lineHeight),
                fontSize: tk(token.title.fontSize),
                fontWeight: tk(token.title.fontWeight),
                position: 'relative',
                zIndex: 1,
                background: tk(token.background),
                boxShadow: `inset 0 -1px ${tk(token.scrollSplitColor)}`,
            },
            [`.${dialogClasses.scrollAtTop}& .${dialogClasses.titleRoot}`]: {
                background: 'transparent',
                boxShadow: 'none',
            },
            [`.${dialogClasses.titleWithButton}`]: {
                paddingRight: '52px',
            },
            // content style
            [`.${dialogClasses.contentRoot}`]: {
                padding: 0,
                flex: 1,
                color: tk(token.content.color),
                minHeight: tk(token.content.minHeight),
                lineHeight: tk(token.content.lineHeight),
                fontSize: tk(token.content.fontSize),
                fontWeight: tk(token.content.fontWeight),
                // We use the magical negative margin (and an extra padding in the scroller below) to prevent focus indicator cropping
                marginBottom: '-4px',
                overflow: 'hidden',
                [`&.${dialogClasses.disabledContentScrollView}`]: {
                    overflow: 'auto',
                },
                [`.${dialogClasses.content}`]: {
                    padding: tk(token.padding),
                    paddingBottom: '4px',
                },
                '&:last-child': {
                    marginBottom: 0,
                    [`.${dialogClasses.content}`]: {
                        paddingBottom: tk(token.padding),
                    },
                },
            },
            // We use the magical negative margin (and an extra padding in the scroller below) to prevent focus indicator cropping
            [`.${dialogClasses.titleRoot} ~ .${dialogClasses.contentRoot}`]: {
                marginTop: '-4px',
                [`.${dialogClasses.content}`]: {
                    paddingTop: '4px',
                },
            },
            // footer style
            [`.${dialogClasses.footerRoot}`]: {
                padding: tk(token.padding),
                zIndex: 1,
                background: tk(token.background),
                boxShadow: `inset 0 1px ${tk(token.scrollSplitColor)}`,
            },
            [`.${dialogClasses.scrollAtBottom}& .${dialogClasses.footerRoot}`]: {
                background: 'transparent',
                boxShadow: 'none',
            },
            // close icon
            [`.${dialogClasses.closeIcon}`]: {
                position: 'absolute',
                right: tk(token.padding),
                top: tk(token.padding),
                zIndex: 2,
            },
        },
        // backdrop
        [`.${dialogClasses.backdrop}`]: {
            background: tk(token.backdropColor),
        },
    };
    return styles;
}
